module.exports = __webpack_public_path__ + "img/mug-saucer.fc1911f3.svg";